export const StatementsAnimation = {
  nm: "09",
  h: 281,
  w: 281,
  meta: { g: "LottieFiles Figma v92" },
  layers: [
    {
      ty: 4,
      nm: "Ellipse 21 (Stroke)",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [16.5, 63.5],
              t: 0,
            },
            { s: [8, 63.5], t: 75 },
          ],
        },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [93.5, 117.5],
              t: 0,
            },
            { s: [70, 117.5], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.36, 0],
                      [0, 0],
                      [0.605, 0.26],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0.4, 0.171],
                      [0, 0],
                      [-0.623, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [15.364, 124.953],
                      [16.5, 125.2],
                      [16.5, 127],
                      [14.656, 126.606],
                      [14.876, 126.095],
                      [15.364, 124.953],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.17, 0],
                      [0, 0],
                      [0.29, 0.26],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0.19, 0.17],
                      [0, 0],
                      [-0.3, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [7.45, 124.95],
                      [8, 125.2],
                      [8, 127],
                      [7.11, 126.61],
                      [7.21, 126.1],
                      [7.45, 124.95],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.623, 0],
                      [0, 0],
                      [-0.4, 0.171],
                      [0, 0],
                    ],
                    o: [
                      [-0.605, 0.259],
                      [0, 0],
                      [0.36, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [18.343, 126.606],
                      [16.5, 127],
                      [16.5, 125.2],
                      [17.636, 124.953],
                      [18.343, 126.606],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.3, 0],
                      [0, 0],
                      [-0.19, 0.17],
                      [0, 0],
                    ],
                    o: [
                      [-0.29, 0.26],
                      [0, 0],
                      [0.17, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [8.89, 126.61],
                      [8, 127],
                      [8, 125.2],
                      [8.55, 124.95],
                      [8.89, 126.61],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.639, -0.747],
                      [0, 0],
                      [0.687, 1.225],
                      [0, 0],
                    ],
                    o: [
                      [0.643, 1.148],
                      [0, 0],
                      [-0.734, -0.858],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [11.138, 120.261],
                      [13.068, 123.102],
                      [11.702, 124.27],
                      [9.569, 121.139],
                      [11.138, 120.261],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.31, -0.75],
                      [0, 0],
                      [0.33, 1.23],
                      [0, 0],
                    ],
                    o: [
                      [0.31, 1.15],
                      [0, 0],
                      [-0.36, -0.86],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [5.4, 120.26],
                      [6.34, 123.1],
                      [5.67, 124.27],
                      [4.64, 121.14],
                      [5.4, 120.26],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.734, -0.858],
                      [0, 0],
                      [-0.643, 1.148],
                      [0, 0],
                    ],
                    o: [
                      [-0.687, 1.225],
                      [0, 0],
                      [0.64, -0.747],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [23.43, 121.139],
                      [21.297, 124.27],
                      [19.932, 123.102],
                      [21.862, 120.261],
                      [23.43, 121.139],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.36, -0.86],
                      [0, 0],
                      [-0.31, 1.15],
                      [0, 0],
                    ],
                    o: [
                      [-0.33, 1.23],
                      [0, 0],
                      [0.31, -0.75],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [11.36, 121.14],
                      [10.33, 124.27],
                      [9.66, 123.1],
                      [10.6, 120.26],
                      [11.36, 121.14],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.448, -1.054],
                      [0, 0],
                      [0.434, 1.265],
                      [0, 0],
                    ],
                    o: [
                      [0.422, 1.23],
                      [0, 0],
                      [-0.466, -1.098],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [8.256, 113.585],
                      [9.563, 117.013],
                      [7.906, 117.716],
                      [6.555, 114.169],
                      [8.256, 113.585],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.22, -1.05],
                      [0, 0],
                      [0.21, 1.27],
                      [0, 0],
                    ],
                    o: [
                      [0.2, 1.23],
                      [0, 0],
                      [-0.23, -1.1],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [4, 113.59],
                      [4.64, 117.01],
                      [3.83, 117.72],
                      [3.18, 114.17],
                      [4, 113.59],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.467, -1.098],
                      [0, 0],
                      [0, 0],
                      [-0.422, 1.23],
                      [0, 0],
                    ],
                    o: [
                      [-0.434, 1.265],
                      [0, 0],
                      [0, 0],
                      [0.448, -1.054],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [26.444, 114.169],
                      [25.093, 117.716],
                      [24.266, 117.365],
                      [23.438, 117.013],
                      [24.744, 113.585],
                      [26.444, 114.169],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.23, -1.1],
                      [0, 0],
                      [0, 0],
                      [-0.2, 1.23],
                      [0, 0],
                    ],
                    o: [
                      [-0.21, 1.27],
                      [0, 0],
                      [0, 0],
                      [0.22, -1.05],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [12.82, 114.17],
                      [12.17, 117.72],
                      [11.77, 117.37],
                      [11.36, 117.01],
                      [12, 113.59],
                      [12.82, 114.17],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.328, -1.145],
                      [0, 0],
                      [0.309, 1.272],
                      [0, 0],
                    ],
                    o: [
                      [0.304, 1.25],
                      [0, 0],
                      [-0.335, -1.17],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [6.198, 106.451],
                      [7.146, 110.045],
                      [5.417, 110.54],
                      [4.45, 106.875],
                      [6.198, 106.451],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.16, -1.14],
                      [0, 0],
                      [0.15, 1.27],
                      [0, 0],
                    ],
                    o: [
                      [0.15, 1.25],
                      [0, 0],
                      [-0.16, -1.17],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [3.01, 106.45],
                      [3.46, 110.05],
                      [2.63, 110.54],
                      [2.16, 106.88],
                      [3.01, 106.45],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.335, -1.17],
                      [0, 0],
                      [-0.304, 1.25],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.309, 1.272],
                      [0, 0],
                      [0.328, -1.145],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [27.675, 106.663],
                      [28.549, 106.875],
                      [27.582, 110.54],
                      [25.854, 110.045],
                      [26.802, 106.451],
                      [27.675, 106.663],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.16, -1.17],
                      [0, 0],
                      [-0.15, 1.25],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.15, 1.27],
                      [0, 0],
                      [0.16, -1.14],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [13.42, 106.66],
                      [13.84, 106.88],
                      [13.37, 110.54],
                      [12.54, 110.05],
                      [12.99, 106.45],
                      [13.42, 106.66],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.248, -1.192],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.229, 1.279],
                      [0, 0],
                    ],
                    o: [
                      [0.226, 1.263],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.252, -1.209],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [4.666, 99.119],
                      [5.377, 102.803],
                      [4.495, 102.985],
                      [4.496, 102.986],
                      [3.616, 103.168],
                      [2.896, 99.435],
                      [4.666, 99.119],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.12, -1.19],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.11, 1.28],
                      [0, 0],
                    ],
                    o: [
                      [0.11, 1.26],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.12, -1.21],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2.26, 99.12],
                      [2.61, 102.8],
                      [2.18, 102.99],
                      [2.18, 102.99],
                      [1.75, 103.17],
                      [1.4, 99.43],
                      [2.26, 99.12],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.252, -1.209],
                      [0, 0],
                      [0, 0],
                      [-0.226, 1.263],
                      [0, 0],
                    ],
                    o: [
                      [-0.229, 1.279],
                      [0, 0],
                      [0, 0],
                      [0.248, -1.192],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [30.104, 99.435],
                      [29.383, 103.168],
                      [28.504, 102.986],
                      [27.623, 102.803],
                      [28.334, 99.119],
                      [30.104, 99.435],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.12, -1.21],
                      [0, 0],
                      [0, 0],
                      [-0.11, 1.26],
                      [0, 0],
                    ],
                    o: [
                      [-0.11, 1.28],
                      [0, 0],
                      [0, 0],
                      [0.12, -1.19],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [14.6, 99.43],
                      [14.25, 103.17],
                      [13.82, 102.99],
                      [13.39, 102.8],
                      [13.74, 99.12],
                      [14.6, 99.43],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.186, -1.214],
                      [0, 0],
                      [0.167, 1.279],
                      [0, 0],
                    ],
                    o: [
                      [0.165, 1.266],
                      [0, 0],
                      [-0.188, -1.228],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [3.526, 91.696],
                      [4.054, 95.417],
                      [2.275, 95.689],
                      [1.742, 91.928],
                      [3.526, 91.696],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.09, -1.21],
                      [0, 0],
                      [0.08, 1.28],
                      [0, 0],
                    ],
                    o: [
                      [0.08, 1.27],
                      [0, 0],
                      [-0.09, -1.23],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.71, 91.7],
                      [1.97, 95.42],
                      [1.1, 95.69],
                      [0.84, 91.93],
                      [1.71, 91.7],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.188, -1.228],
                      [0, 0],
                      [0, 0],
                      [-0.165, 1.266],
                      [0, 0],
                    ],
                    o: [
                      [-0.167, 1.279],
                      [0, 0],
                      [0, 0],
                      [0.186, -1.214],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [31.257, 91.928],
                      [30.724, 95.689],
                      [29.836, 95.554],
                      [28.946, 95.417],
                      [29.474, 91.696],
                      [31.257, 91.928],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.09, -1.23],
                      [0, 0],
                      [0, 0],
                      [-0.08, 1.27],
                      [0, 0],
                    ],
                    o: [
                      [-0.08, 1.28],
                      [0, 0],
                      [0, 0],
                      [0.09, -1.21],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [15.15, 91.93],
                      [14.9, 95.69],
                      [14.47, 95.55],
                      [14.03, 95.42],
                      [14.29, 91.7],
                      [15.15, 91.93],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.134, -1.227],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.115, 1.277],
                      [0, 0],
                    ],
                    o: [
                      [0.114, 1.266],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.136, -1.239],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2.705, 84.213],
                      [3.078, 87.953],
                      [2.183, 88.051],
                      [2.184, 88.052],
                      [1.289, 88.148],
                      [0.913, 84.374],
                      [2.705, 84.213],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.07, -1.23],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.06, 1.28],
                      [0, 0],
                    ],
                    o: [
                      [0.06, 1.27],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.07, -1.24],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.31, 84.21],
                      [1.49, 87.95],
                      [1.06, 88.05],
                      [1.06, 88.05],
                      [0.63, 88.15],
                      [0.44, 84.37],
                      [1.31, 84.21],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.136, -1.239],
                      [0, 0],
                      [-0.114, 1.266],
                      [0, 0],
                    ],
                    o: [
                      [-0.115, 1.277],
                      [0, 0],
                      [0.134, -1.227],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [32.086, 84.374],
                      [31.71, 88.148],
                      [29.922, 87.953],
                      [30.295, 84.213],
                      [32.086, 84.374],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.07, -1.24],
                      [0, 0],
                      [-0.06, 1.27],
                      [0, 0],
                    ],
                    o: [
                      [-0.06, 1.28],
                      [0, 0],
                      [0.07, -1.23],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [15.56, 84.37],
                      [15.37, 88.15],
                      [14.51, 87.95],
                      [14.69, 84.21],
                      [15.56, 84.37],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.09, -1.24],
                      [0, 0],
                      [0.071, 1.28],
                      [0, 0],
                    ],
                    o: [
                      [0.07, 1.27],
                      [0, 0],
                      [-0.091, -1.25],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2.159, 76.694],
                      [2.399, 80.459],
                      [0.604, 80.588],
                      [0.362, 76.793],
                      [2.159, 76.694],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.04, -1.24],
                      [0, 0],
                      [0.03, 1.28],
                      [0, 0],
                    ],
                    o: [
                      [0.03, 1.27],
                      [0, 0],
                      [-0.04, -1.25],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.05, 76.69],
                      [1.16, 80.46],
                      [0.29, 80.59],
                      [0.18, 76.79],
                      [1.05, 76.69],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.091, -1.25],
                      [0, 0],
                      [-0.07, 1.27],
                      [0, 0],
                    ],
                    o: [
                      [-0.071, 1.28],
                      [0, 0],
                      [0.09, -1.24],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [32.637, 76.793],
                      [32.395, 80.588],
                      [30.601, 80.459],
                      [30.841, 76.694],
                      [32.637, 76.793],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.04, -1.25],
                      [0, 0],
                      [-0.03, 1.27],
                      [0, 0],
                    ],
                    o: [
                      [-0.03, 1.28],
                      [0, 0],
                      [0.04, -1.24],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [15.82, 76.79],
                      [15.71, 80.59],
                      [14.84, 80.46],
                      [14.95, 76.69],
                      [15.82, 76.79],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.048, -1.243],
                      [0, 0],
                      [0, 0],
                      [0.03, 1.276],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0.029, 1.266],
                      [0, 0],
                      [0, 0],
                      [-0.049, -1.253],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.865, 69.161],
                      [1.981, 72.927],
                      [1.082, 72.961],
                      [0.184, 72.996],
                      [0.066, 69.201],
                      [0.966, 69.182],
                      [1.865, 69.161],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.02, -1.24],
                      [0, 0],
                      [0, 0],
                      [0.01, 1.28],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0.01, 1.27],
                      [0, 0],
                      [0, 0],
                      [-0.02, -1.25],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0.9, 69.16],
                      [0.96, 72.93],
                      [0.52, 72.96],
                      [0.09, 73],
                      [0.03, 69.2],
                      [0.47, 69.18],
                      [0.9, 69.16],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.049, -1.253],
                      [0, 0],
                      [0, 0],
                      [-0.029, 1.266],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.029, 1.276],
                      [0, 0],
                      [0, 0],
                      [0.048, -1.243],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [32.034, 69.182],
                      [32.933, 69.201],
                      [32.815, 72.996],
                      [31.917, 72.962],
                      [31.019, 72.927],
                      [31.135, 69.161],
                      [32.034, 69.182],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.02, -1.25],
                      [0, 0],
                      [0, 0],
                      [-0.01, 1.27],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.01, 1.28],
                      [0, 0],
                      [0, 0],
                      [0.02, -1.24],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [15.53, 69.18],
                      [15.97, 69.2],
                      [15.91, 73],
                      [15.47, 72.96],
                      [15.04, 72.93],
                      [15.1, 69.16],
                      [15.53, 69.18],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.005, 0.633],
                      [0, 0],
                      [0, -0.632],
                      [-0.005, -0.628],
                      [0, 0],
                      [0, 0.637],
                    ],
                    o: [
                      [0, -0.637],
                      [0, 0],
                      [-0.005, 0.628],
                      [0, 0.632],
                      [0, 0],
                      [-0.005, -0.632],
                      [0, 0],
                    ],
                    v: [
                      [0, 63.5],
                      [0.008, 61.596],
                      [1.808, 61.609],
                      [1.8, 63.5],
                      [1.808, 65.391],
                      [0.008, 65.403],
                      [0, 63.5],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0.63],
                      [0, 0],
                      [0, -0.63],
                      [0, -0.63],
                      [0, 0],
                      [0, 0.64],
                    ],
                    o: [
                      [0, -0.64],
                      [0, 0],
                      [0, 0.63],
                      [0, 0.63],
                      [0, 0],
                      [0, -0.63],
                      [0, 0],
                    ],
                    v: [
                      [0, 63.5],
                      [0, 61.6],
                      [0.88, 61.61],
                      [0.87, 63.5],
                      [0.88, 65.39],
                      [0, 65.4],
                      [0, 63.5],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.005, -0.632],
                      [0, 0],
                      [0, 0.632],
                      [0.005, 0.628],
                      [0, 0],
                      [0, -0.637],
                    ],
                    o: [
                      [0, 0.637],
                      [0, 0],
                      [0.005, -0.628],
                      [0, -0.632],
                      [0, 0],
                      [0.005, 0.633],
                      [0, 0],
                    ],
                    v: [
                      [33, 63.5],
                      [32.991, 65.403],
                      [31.192, 65.391],
                      [31.2, 63.5],
                      [31.192, 61.609],
                      [32.991, 61.596],
                      [33, 63.5],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -0.63],
                      [0, 0],
                      [0, 0.63],
                      [0, 0.63],
                      [0, 0],
                      [0, -0.64],
                    ],
                    o: [
                      [0, 0.64],
                      [0, 0],
                      [0, -0.63],
                      [0, -0.63],
                      [0, 0],
                      [0, 0.63],
                      [0, 0],
                    ],
                    v: [
                      [16, 63.5],
                      [16, 65.4],
                      [15.12, 65.39],
                      [15.13, 63.5],
                      [15.12, 61.61],
                      [16, 61.6],
                      [16, 63.5],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.029, -1.267],
                      [0, 0],
                      [-0.049, 1.253],
                      [0, 0],
                    ],
                    o: [
                      [-0.048, 1.243],
                      [0, 0],
                      [0.03, -1.276],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.981, 54.073],
                      [1.865, 57.839],
                      [0.066, 57.798],
                      [0.184, 54.003],
                      [1.981, 54.073],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.01, -1.27],
                      [0, 0],
                      [-0.02, 1.25],
                      [0, 0],
                    ],
                    o: [
                      [-0.02, 1.24],
                      [0, 0],
                      [0.01, -1.28],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0.96, 54.07],
                      [0.9, 57.84],
                      [0.03, 57.8],
                      [0.09, 54],
                      [0.96, 54.07],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.029, -1.276],
                      [0, 0],
                      [0.048, 1.243],
                      [0, 0],
                    ],
                    o: [
                      [0.049, 1.253],
                      [0, 0],
                      [-0.029, -1.267],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [32.815, 54.003],
                      [32.933, 57.798],
                      [31.135, 57.839],
                      [31.019, 54.073],
                      [32.815, 54.003],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.01, -1.28],
                      [0, 0],
                      [0.02, 1.24],
                      [0, 0],
                    ],
                    o: [
                      [0.02, 1.25],
                      [0, 0],
                      [-0.01, -1.27],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [15.91, 54],
                      [15.97, 57.8],
                      [15.1, 57.84],
                      [15.04, 54.07],
                      [15.91, 54],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.07, -1.27],
                      [0, 0],
                      [-0.091, 1.25],
                      [0, 0],
                    ],
                    o: [
                      [-0.09, 1.24],
                      [0, 0],
                      [0.071, -1.28],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2.399, 46.541],
                      [2.159, 50.306],
                      [0.362, 50.206],
                      [0.604, 46.411],
                      [2.399, 46.541],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.03, -1.27],
                      [0, 0],
                      [-0.04, 1.25],
                      [0, 0],
                    ],
                    o: [
                      [-0.04, 1.24],
                      [0, 0],
                      [0.03, -1.28],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.16, 46.54],
                      [1.05, 50.31],
                      [0.18, 50.21],
                      [0.29, 46.41],
                      [1.16, 46.54],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.071, -1.28],
                      [0, 0],
                      [0.09, 1.24],
                      [0, 0],
                    ],
                    o: [
                      [0.091, 1.25],
                      [0, 0],
                      [-0.07, -1.27],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [32.395, 46.411],
                      [32.637, 50.206],
                      [30.841, 50.306],
                      [30.601, 46.541],
                      [32.395, 46.411],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.03, -1.28],
                      [0, 0],
                      [0.04, 1.24],
                      [0, 0],
                    ],
                    o: [
                      [0.04, 1.25],
                      [0, 0],
                      [-0.03, -1.27],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [15.71, 46.41],
                      [15.82, 50.21],
                      [14.95, 50.31],
                      [14.84, 46.54],
                      [15.71, 46.41],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.114, -1.266],
                      [0, 0],
                      [-0.136, 1.239],
                      [0, 0],
                    ],
                    o: [
                      [-0.134, 1.227],
                      [0, 0],
                      [0.115, -1.277],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [3.078, 39.047],
                      [2.705, 42.787],
                      [0.913, 42.625],
                      [1.289, 38.851],
                      [3.078, 39.047],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.06, -1.27],
                      [0, 0],
                      [-0.07, 1.24],
                      [0, 0],
                    ],
                    o: [
                      [-0.07, 1.23],
                      [0, 0],
                      [0.06, -1.28],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.49, 39.05],
                      [1.31, 42.79],
                      [0.44, 42.63],
                      [0.63, 38.85],
                      [1.49, 39.05],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.115, -1.277],
                      [0, 0],
                      [0.134, 1.227],
                      [0, 0],
                    ],
                    o: [
                      [0.136, 1.239],
                      [0, 0],
                      [-0.114, -1.266],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [31.71, 38.851],
                      [32.086, 42.625],
                      [30.295, 42.787],
                      [29.922, 39.047],
                      [31.71, 38.851],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.06, -1.28],
                      [0, 0],
                      [0.07, 1.23],
                      [0, 0],
                    ],
                    o: [
                      [0.07, 1.24],
                      [0, 0],
                      [-0.06, -1.27],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [15.37, 38.85],
                      [15.56, 42.63],
                      [14.69, 42.79],
                      [14.51, 39.05],
                      [15.37, 38.85],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.165, -1.266],
                      [0, 0],
                      [-0.188, 1.228],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.186, 1.214],
                      [0, 0],
                      [0.167, -1.279],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [3.164, 31.446],
                      [4.054, 31.583],
                      [3.526, 35.304],
                      [1.742, 35.071],
                      [2.275, 31.311],
                      [3.164, 31.446],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.08, -1.27],
                      [0, 0],
                      [-0.09, 1.23],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.09, 1.21],
                      [0, 0],
                      [0.08, -1.28],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [1.53, 31.45],
                      [1.97, 31.58],
                      [1.71, 35.3],
                      [0.84, 35.07],
                      [1.1, 31.31],
                      [1.53, 31.45],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.167, -1.279],
                      [0, 0],
                      [0.186, 1.214],
                      [0, 0],
                    ],
                    o: [
                      [0.188, 1.228],
                      [0, 0],
                      [-0.165, -1.266],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [30.724, 31.311],
                      [31.257, 35.071],
                      [29.474, 35.304],
                      [28.946, 31.583],
                      [30.724, 31.311],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.08, -1.28],
                      [0, 0],
                      [0.09, 1.21],
                      [0, 0],
                    ],
                    o: [
                      [0.09, 1.23],
                      [0, 0],
                      [-0.08, -1.27],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [14.9, 31.31],
                      [15.15, 35.07],
                      [14.29, 35.3],
                      [14.03, 31.58],
                      [14.9, 31.31],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.226, -1.263],
                      [0, 0],
                      [-0.252, 1.209],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.248, 1.192],
                      [0, 0],
                      [0.229, -1.279],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [4.496, 24.014],
                      [5.377, 24.197],
                      [4.666, 27.881],
                      [2.896, 27.565],
                      [3.616, 23.831],
                      [4.496, 24.014],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.11, -1.26],
                      [0, 0],
                      [-0.12, 1.21],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.12, 1.19],
                      [0, 0],
                      [0.11, -1.28],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2.18, 24.01],
                      [2.61, 24.2],
                      [2.26, 27.88],
                      [1.4, 27.56],
                      [1.75, 23.83],
                      [2.18, 24.01],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.229, -1.279],
                      [0, 0],
                      [0.248, 1.192],
                      [0, 0],
                    ],
                    o: [
                      [0.252, 1.209],
                      [0, 0],
                      [-0.226, -1.263],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [29.383, 23.831],
                      [30.104, 27.565],
                      [28.334, 27.881],
                      [27.623, 24.197],
                      [29.383, 23.831],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.11, -1.28],
                      [0, 0],
                      [0.12, 1.19],
                      [0, 0],
                    ],
                    o: [
                      [0.12, 1.21],
                      [0, 0],
                      [-0.11, -1.26],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [14.25, 23.83],
                      [14.6, 27.56],
                      [13.74, 27.88],
                      [13.39, 24.2],
                      [14.25, 23.83],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.304, -1.25],
                      [0, 0],
                      [0, 0],
                      [-0.335, 1.17],
                      [0, 0],
                    ],
                    o: [
                      [-0.328, 1.145],
                      [0, 0],
                      [0, 0],
                      [0.309, -1.272],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [7.146, 16.955],
                      [6.198, 20.549],
                      [5.324, 20.336],
                      [4.45, 20.124],
                      [5.417, 16.459],
                      [7.146, 16.955],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.15, -1.25],
                      [0, 0],
                      [0, 0],
                      [-0.16, 1.17],
                      [0, 0],
                    ],
                    o: [
                      [-0.16, 1.15],
                      [0, 0],
                      [0, 0],
                      [0.15, -1.27],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [3.46, 16.96],
                      [3.01, 20.55],
                      [2.58, 20.34],
                      [2.16, 20.12],
                      [2.63, 16.46],
                      [3.46, 16.96],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.309, -1.272],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.328, 1.145],
                      [0, 0],
                    ],
                    o: [
                      [0.335, 1.17],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.304, -1.25],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [27.582, 16.459],
                      [28.549, 20.124],
                      [27.676, 20.337],
                      [27.675, 20.336],
                      [26.802, 20.549],
                      [25.854, 16.955],
                      [27.582, 16.459],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.15, -1.27],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.16, 1.15],
                      [0, 0],
                    ],
                    o: [
                      [0.16, 1.17],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.15, -1.25],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [13.37, 16.46],
                      [13.84, 20.12],
                      [13.42, 20.34],
                      [13.42, 20.34],
                      [12.99, 20.55],
                      [12.54, 16.96],
                      [13.37, 16.46],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.422, -1.23],
                      [0, 0],
                      [-0.466, 1.097],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.448, 1.054],
                      [0, 0],
                      [0.434, -1.265],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [8.734, 9.635],
                      [9.563, 9.987],
                      [8.256, 13.415],
                      [6.555, 12.83],
                      [7.906, 9.283],
                      [8.734, 9.635],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.2, -1.23],
                      [0, 0],
                      [-0.23, 1.1],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.22, 1.05],
                      [0, 0],
                      [0.21, -1.27],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [4.23, 9.63],
                      [4.64, 9.99],
                      [4, 13.42],
                      [3.18, 12.83],
                      [3.83, 9.28],
                      [4.23, 9.63],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.434, -1.265],
                      [0, 0],
                      [0.448, 1.054],
                      [0, 0],
                    ],
                    o: [
                      [0.467, 1.097],
                      [0, 0],
                      [-0.422, -1.23],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [25.093, 9.283],
                      [26.444, 12.83],
                      [24.744, 13.415],
                      [23.438, 9.987],
                      [25.093, 9.283],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.21, -1.27],
                      [0, 0],
                      [0.22, 1.05],
                      [0, 0],
                    ],
                    o: [
                      [0.23, 1.1],
                      [0, 0],
                      [-0.2, -1.23],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [12.17, 9.28],
                      [12.82, 12.83],
                      [12, 13.42],
                      [11.36, 9.99],
                      [12.17, 9.28],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.643, -1.148],
                      [0, 0],
                      [-0.734, 0.857],
                      [0, 0],
                    ],
                    o: [
                      [-0.639, 0.747],
                      [0, 0],
                      [0.687, -1.225],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [13.068, 3.898],
                      [11.138, 6.739],
                      [9.569, 5.86],
                      [11.702, 2.729],
                      [13.068, 3.898],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.31, -1.15],
                      [0, 0],
                      [-0.36, 0.86],
                      [0, 0],
                    ],
                    o: [
                      [-0.31, 0.75],
                      [0, 0],
                      [0.33, -1.23],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [6.34, 3.9],
                      [5.4, 6.74],
                      [4.64, 5.86],
                      [5.67, 2.73],
                      [6.34, 3.9],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.687, -1.225],
                      [0, 0],
                      [0.64, 0.747],
                      [0, 0],
                    ],
                    o: [
                      [0.734, 0.857],
                      [0, 0],
                      [-0.643, -1.148],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [21.297, 2.729],
                      [23.43, 5.86],
                      [21.862, 6.739],
                      [19.932, 3.898],
                      [21.297, 2.729],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.33, -1.23],
                      [0, 0],
                      [0.31, 0.75],
                      [0, 0],
                    ],
                    o: [
                      [0.36, 0.86],
                      [0, 0],
                      [-0.31, -1.15],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [10.33, 2.73],
                      [11.36, 5.86],
                      [10.6, 6.74],
                      [9.66, 3.9],
                      [10.33, 2.73],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.605, -0.259],
                      [0, 0],
                      [0.36, 0],
                      [0.4, -0.171],
                      [0, 0],
                      [-0.623, 0],
                    ],
                    o: [
                      [0.623, 0],
                      [0, 0],
                      [-0.4, -0.171],
                      [-0.36, 0],
                      [0, 0],
                      [0.605, -0.259],
                      [0, 0],
                    ],
                    v: [
                      [16.5, 0],
                      [18.343, 0.393],
                      [17.636, 2.047],
                      [16.5, 1.8],
                      [15.364, 2.047],
                      [14.656, 0.393],
                      [16.5, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.29, -0.26],
                      [0, 0],
                      [0.17, 0],
                      [0.19, -0.17],
                      [0, 0],
                      [-0.3, 0],
                    ],
                    o: [
                      [0.3, 0],
                      [0, 0],
                      [-0.19, -0.17],
                      [-0.17, 0],
                      [0, 0],
                      [0.29, -0.26],
                      [0, 0],
                    ],
                    v: [
                      [8, 0],
                      [8.89, 0.39],
                      [8.55, 2.05],
                      [8, 1.8],
                      [7.45, 2.05],
                      [7.11, 0.39],
                      [8, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 1,
    },
    {
      ty: 4,
      nm: "Ellipse 20",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [31.5, 63.5],
              t: 0,
            },
            { s: [10, 63.5], t: 75 },
          ],
        },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [109.4, 118.4],
              t: 0,
            },
            { s: [87.9, 118.4], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [16.9, 0],
                      [0, 34.573],
                      [-16.9, 0],
                      [0, -34.573],
                    ],
                    o: [
                      [0, 34.573],
                      [-16.9, 0],
                      [0, -34.573],
                      [16.9, 0],
                      [0, 0],
                    ],
                    v: [
                      [61.2, 62.6],
                      [30.6, 125.2],
                      [0, 62.6],
                      [30.6, 0],
                      [61.2, 62.6],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [5.023, 0],
                      [0, 34.573],
                      [-5.023, 0],
                      [0, -34.573],
                    ],
                    o: [
                      [0, 34.573],
                      [-5.023, 0],
                      [0, -34.573],
                      [5.023, 0],
                      [0, 0],
                    ],
                    v: [
                      [18.2, 62.6],
                      [9.1, 125.2],
                      [0, 62.6],
                      [9.1, 0],
                      [18.2, 62.6],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "st",
          nm: "",
          lc: 1,
          lj: 1,
          ml: 4,
          o: { a: 0, k: 100 },
          w: {
            a: 1,
            k: [
              { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [1.8], t: 0 },
              { s: [1.8], t: 75 },
            ],
          },
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
        },
      ],
      ind: 2,
    },
    {
      ty: 4,
      nm: "Ellipse 19",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [47.5, 63.5],
              t: 0,
            },
            { s: [21, 63.5], t: 75 },
          ],
        },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [125.4, 118.4],
              t: 0,
            },
            { s: [98.9, 118.4], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [25.736, 0],
                      [0, 34.573],
                      [-25.736, 0],
                      [0, -34.573],
                    ],
                    o: [
                      [0, 34.573],
                      [-25.736, 0],
                      [0, -34.573],
                      [25.736, 0],
                      [0, 0],
                    ],
                    v: [
                      [93.2, 62.6],
                      [46.6, 125.2],
                      [0, 62.6],
                      [46.6, 0],
                      [93.2, 62.6],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [11.103, 0],
                      [0, 34.573],
                      [-11.103, 0],
                      [0, -34.573],
                    ],
                    o: [
                      [0, 34.573],
                      [-11.103, 0],
                      [0, -34.573],
                      [11.103, 0],
                      [0, 0],
                    ],
                    v: [
                      [40.2, 62.6],
                      [20.1, 125.2],
                      [0, 62.6],
                      [20.1, 0],
                      [40.2, 62.6],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "st",
          nm: "",
          lc: 1,
          lj: 1,
          ml: 4,
          o: { a: 0, k: 100 },
          w: {
            a: 1,
            k: [
              { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [1.8], t: 0 },
              { s: [1.8], t: 75 },
            ],
          },
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
        },
      ],
      ind: 3,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [63.52, 63.73] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [141.02, 118.23] },
        r: {
          a: 1,
          k: [
            { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [0], t: 0 },
            { s: [-15.65], t: 75 },
          ],
        },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.078, 0.026],
                      [0, 0],
                      [11.278, 0],
                      [7.77, 3.288],
                      [5.788, 5.787],
                      [3.174, 7.504],
                      [0, 8.507],
                      [-3.287, 7.769],
                      [-5.788, 5.788],
                      [-7.506, 3.174],
                      [-8.508, 0],
                      [-11.987, -13.813],
                      [0, -15.177],
                      [7.76, -10.764],
                      [0, 0],
                      [0.203, -0.212],
                      [0.204, 0],
                      [0, 0],
                    ],
                    o: [
                      [-0.079, 0],
                      [0, 0],
                      [-9.658, 5.7],
                      [-8.508, 0],
                      [-7.504, -3.174],
                      [-5.788, -5.788],
                      [-3.289, -7.771],
                      [0, -8.507],
                      [3.174, -7.504],
                      [5.788, -5.788],
                      [7.771, -3.289],
                      [18.274, 0],
                      [9.935, 11.448],
                      [0, 13.324],
                      [0, 0],
                      [0.103, 0.275],
                      [-0.146, 0.153],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [123.134, 126.45],
                      [122.898, 126.412],
                      [95.014, 117.339],
                      [63.024, 126.05],
                      [38.493, 121.096],
                      [18.46, 107.591],
                      [4.955, 87.557],
                      [0, 63.026],
                      [4.953, 38.494],
                      [18.459, 18.461],
                      [38.491, 4.955],
                      [63.024, 0],
                      [110.641, 21.736],
                      [126.047, 63.024],
                      [114.186, 99.832],
                      [123.846, 125.415],
                      [123.684, 126.213],
                      [123.131, 126.448],
                      [123.134, 126.45],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.079, 0.03],
                      [0, 0],
                      [11.281, 0],
                      [7.768, 3.284],
                      [5.784, 5.784],
                      [3.175, 7.501],
                      [0, 8.503],
                      [-3.284, 7.769],
                      [-5.784, 5.784],
                      [-7.51, 3.175],
                      [-8.512, 0],
                      [-11.985, -13.811],
                      [0, -15.18],
                      [7.758, -10.765],
                      [0, 0],
                      [0.198, -0.208],
                      [0.208, 0],
                      [0, 0],
                    ],
                    o: [
                      [-0.079, 0],
                      [0, 0],
                      [-9.663, 5.705],
                      [-8.512, 0],
                      [-7.5, -3.175],
                      [-5.784, -5.784],
                      [-3.294, -7.769],
                      [0, -8.503],
                      [3.175, -7.501],
                      [5.784, -5.784],
                      [7.768, -3.294],
                      [18.275, 0],
                      [9.931, 11.449],
                      [0, 13.325],
                      [0, 0],
                      [0.099, 0.278],
                      [-0.149, 0.149],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [123.133, 126.45],
                      [122.895, 126.41],
                      [95.016, 117.342],
                      [63.02, 126.053],
                      [38.495, 121.092],
                      [18.464, 107.589],
                      [4.951, 87.558],
                      [0, 63.022],
                      [4.951, 38.496],
                      [18.464, 18.464],
                      [38.495, 4.951],
                      [63.02, 0],
                      [110.642, 21.738],
                      [126.05, 63.022],
                      [114.184, 99.831],
                      [123.847, 125.418],
                      [123.689, 126.212],
                      [123.133, 126.45],
                      [123.133, 126.45],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -33.911],
                      [-33.91, 0],
                      [-9.492, 5.674],
                      [-0.209, -0.067],
                      [0, 0],
                      [0, 0],
                      [-0.153, 0.206],
                      [0, 13.138],
                      [9.694, 11.172],
                      [17.831, 0],
                    ],
                    o: [
                      [-33.91, 0],
                      [0, 33.911],
                      [11.119, 0],
                      [0.19, -0.114],
                      [0, 0],
                      [0, 0],
                      [-0.091, -0.241],
                      [7.725, -10.573],
                      [0, -14.809],
                      [-11.699, -13.479],
                      [0, 0],
                    ],
                    v: [
                      [63.024, 1.527],
                      [1.527, 63.026],
                      [63.024, 124.524],
                      [94.53, 115.852],
                      [95.158, 115.78],
                      [121.858, 124.469],
                      [112.614, 99.988],
                      [112.713, 99.269],
                      [124.521, 63.026],
                      [109.489, 22.737],
                      [63.024, 1.527],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -33.912],
                      [-33.911, 0],
                      [-9.495, 5.675],
                      [-0.208, -0.069],
                      [0, 0],
                      [0, 0],
                      [-0.149, 0.208],
                      [0, 13.136],
                      [9.693, 11.172],
                      [17.829, 0],
                    ],
                    o: [
                      [-33.911, 0],
                      [0, 33.912],
                      [11.122, 0],
                      [0.189, -0.109],
                      [0, 0],
                      [0, 0],
                      [-0.089, -0.238],
                      [7.729, -10.576],
                      [0, -14.813],
                      [-11.697, -13.483],
                      [0, 0],
                    ],
                    v: [
                      [63.02, 1.528],
                      [1.528, 63.022],
                      [63.02, 124.525],
                      [94.53, 115.854],
                      [95.155, 115.784],
                      [121.863, 124.466],
                      [112.617, 99.989],
                      [112.716, 99.265],
                      [124.522, 63.022],
                      [109.491, 22.74],
                      [63.02, 1.528],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "st",
          nm: "",
          lc: 1,
          lj: 1,
          ml: 4,
          o: { a: 0, k: 100 },
          w: {
            a: 1,
            k: [
              { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [1], t: 0 },
              { s: [1], t: 75 },
            ],
          },
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: { a: 0, k: [1, 1, 1] },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 4,
    },
  ],
  v: "5.7.0",
  fr: 60,
  op: 75.01,
  ip: 0,
  assets: [],
};
